import { Tag } from 'primereact/tag';

// 그리드 테이블 기본 텍스트 배찌
export const gridBadgeRender = (text,backColor,color) => {
    
    return (
        <div style={{
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
                width:"100%",
                height:"100%",
            }}>
            <Tag value={text} style={{backgroundColor:backColor,color:color}}></Tag>
        </div>
    
    )
}

export const getStatusGroupColor = (statusGroup) => {
    if (statusGroup === 'warning') {
        return "#e71818"

    } else if (statusGroup === 'caution') {
        return "#ca9011"

    } else if (statusGroup === 'safety') {
        return "#1a6b13"
        
    } else if (statusGroup === 'inspection') {
        return "#1053fc"
    }
}

export const getStatusGroupColorNew = (statusGroup) => {
    if (statusGroup === 'warning') {
        return { color: "#EC0D19", backgroundColor: "#FFE2E2" }

    } else if (statusGroup === 'caution') {
        return { color: "#FFA500", backgroundColor: "#FFF8E8" }

    } else if (statusGroup === 'safety') {
        return { color: "#13A82A", backgroundColor: "#E3FFE7" }
        
    } else if (statusGroup === 'inspection') {
        return { color: "#3E63ED", backgroundColor: "#E3E8FF" }
    }
}

export const logingStart = (statusGroup) => {

}

export const logingEnd = (statusGroup) => {

}